import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { ConnectFeed } from './pages/ConnectFeed';
import { ApiKeys } from './pages/ApiKeys';
import { Usage } from './pages/Usage';
import { Billing } from './pages/Billing';
import { BillingSuccess } from './pages/BillingSuccess';
import { AuthShell, AuthSidePane } from './auth/AuthShell';

/**
 * Portal routing. The portal is now a *signed-in app only* — marketing
 * (`/pricing`) lives on the landing page at zynplex.ca, and developer docs
 * (`/docs`) live on docs.zynplex.ca. Anything unauthed routes through
 * Amplify's Authenticator wrapped in our branded split-pane shell.
 */
export default function App() {
  const { authStatus } = useAuthenticator((c) => [c.authStatus]);

  if (authStatus === 'authenticated') {
    return (
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/feeds" element={<ConnectFeed />} />
          <Route path="/api-keys" element={<ApiKeys />} />
          <Route path="/usage" element={<Usage />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/billing/success" element={<BillingSuccess />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    );
  }

  // Not signed in (or still hydrating) → branded split-pane auth screen.
  return (
    <div className="crea-auth-shell">
      <div className="crea-auth-form-pane">
        <div className="crea-auth-form-card">
          <AuthShell>{() => <></>}</AuthShell>
        </div>
      </div>
      <AuthSidePane />
    </div>
  );
}
